<template>
    <Form ref="formRef" :submit="submit">
        <h1 class="leading-none mb-14">
            {{ $dictionary.get('Information.CreateAccount.Steps.AreasOfInterest.Heading') }}
        </h1>
        <p class="text-12 mb-40">
            {{ $dictionary.get('Information.CreateAccount.Steps.AreasOfInterest.Text') }}
        </p>
        <div v-for="(area, sectionKey) in areasOfInterest"
             :key="`areaofinterest-${sectionKey}`">
            <InputCheckbox :id="`areaofinterest-${sectionKey}`"
                           :key="`areaofinterest-${sectionKey}-input`"
                           v-model="area.selected"
                           :name="`areaofinterest-${sectionKey}`"
                           :show-errors="false"
                           with-border
                           :label="area.displayName"
                           :required="!areasInterestNone && !anyAreaOfInterestSelected"
                           @update:modelValue="handleChangeAreaOfInterest"/>
        </div>
        <InputCheckbox id="areaofinterest-none"
                       key="areaofinterest-nonde"
                       v-model="areasInterestNone"
                       name="areaofinterest-none"
                       with-border
                       error-label-key="Information.CreateAccount.Steps.AreasOfInterest.ErrorNoneSelected"
                       :required="!anyAreaOfInterestSelected"
                       :label="$dictionary.get('Information.CreateAccount.Steps.AreasOfInterest.CheckboxToggleNone')"
                       @update:modelValue="toggleToNoneAreasOfInterest"/>
        <div class="mt-50">
            <CallToAction class="w-full mb-20"
                          type="submit"
                          :text="$dictionary.get('Information.CreateAccount.Steps.AreasOfInterest.ButtonSubmit')"/>
        </div>
    </Form>
</template>

<script setup lang="ts">
import { ref, computed, PropType, nextTick, useModel, useTemplateRef } from 'vue';

type FormType = InstanceType<typeof import('@/project/form/Form.vue')['default']>;

const props = defineProps({
    areasOfInterest: {
        type: Array as PropType<{ displayName: string; selected: boolean, key: string }[]>,
        required: true,
    }
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: { displayName: string; selected: boolean, key: string }[]): void,
}>();

const model = useModel(props, 'areasOfInterest', {

});
const areasInterestNone = ref<boolean>(false);
const formRef = useTemplateRef<FormType | null>('formRef');

const anyAreaOfInterestSelected = computed((): boolean => {
    return props.areasOfInterest.some(area => area.selected);
});

function handleChangeAreaOfInterest(): void {
    let noneSelected: boolean = true;
    props.areasOfInterest.forEach(area => {
        if (area.selected === true) {
            noneSelected = false;
        }
    });
    areasInterestNone.value = noneSelected;
    nextTick(() => {
        formRef.value!.handleSubmit(false);
    });
}

function toggleToNoneAreasOfInterest(): void {
    model.value.forEach((area) => {
        area.selected = false;
    });
    nextTick(() => {
        formRef.value!.handleSubmit(false);
    });
}

function submit({ isValid }: { isValid: boolean }): void{
    if (!isValid) {
        return;
    }
    emit('update:modelValue', model.value);
}
</script>
